module.exports = "\r\n<my-app-sidenav [hidden]=\"!logedin\"></my-app-sidenav>\r\n\r\n<section [hidden]=\"!logedin\" id=\"page-container\" class=\"app-page-container\">\r\n  <my-app-header ></my-app-header>\r\n\r\n  <div class=\"app-content-wrapper\">\r\n    <div class=\"app-content\">\r\n      <div class=\"full-height\">\r\n        <router-outlet></router-outlet>\r\n      </div>\r\n    </div>\r\n\r\n    <my-app-footer></my-app-footer>\r\n  </div>\r\n</section>\r\n\r\n<!--<my-app-customizer></my-app-customizer>-->\r\n\r\n<my-app-search-overlay></my-app-search-overlay>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/layout.component.html
// module id = 1010
// module chunks = 32